var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChurnIllustration = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 7.16h3.2v3.24h3.2v3.2h6.4v-3.2h6.4v19.2h-2.8v2.8h5.6V7.5h-5.6v2.885h-.4V7.1h3.2V4H36v32h-6.4v-3.2h-3.2v-3.2h-3.2v-3.2h-6.4v3.2h-3.2v3.24h-3.2V36H4V4h6.4v3.16zm-6 28.44H10v-2.76H7.2V7.16H10V4.4H4.4v31.2zM30 7.1h2.8v25.7H30v2.8h5.6V4.4H30v2.7zM7.6 32.44h5.6V29.6h-2.8V10.4h2.8V7.56H7.6v24.88zm3.2-3.24h5.6v-2.8h-2.8V13.6h2.8v-2.8h-5.6v18.4zm12.8-15.6h2.8v12.8h-2.8v2.8h5.6V10.8h-5.6v2.8zm-3.4 3.2h3v6.4h-3V26H26V14h-5.8v2.8zM14 26h5.8v-2.8h-3v-6.4h3V14H14v12zm3.2-3.2h5.6v-5.6h-5.6v5.6z",
    fill: "#fff"
  })));
};
export default SvgChurnIllustration;